/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { downloadCSV } from "../utils";

import * as reportActions from "../../../actions/reportActions";
import * as userActions from "../../../actions/userActions";
import * as exportActions from "../../../actions/exportActions";

import { formatDate } from "../../../helpers/date";

import Loading from "../../common/Loading";

import Filters from "./MonthlyRevenueAnalysisFilters";
import { LEVEL_3_COLUMNS } from "./columns";

const MonthlyRevenueAnalysis = ({
  isMobile,
  report,
  loading,
  exported,
  exporting,
  actions
}) => {
  const [state, setState] = useState({
    page: 0,
    pageSize: localStorage.getItem("DEFAULT_PAGE_SIZE_CALL_LIST")
      ? parseInt(localStorage.getItem("DEFAULT_PAGE_SIZE_CALL_LIST"))
      : 10
  });

  const onPageChange = (e) => {
    setState((prev) => ({ ...prev, page: e }));
  };

  const onPageSizeChange = (e) => {
    setState((prev) => ({ ...prev, pageSize: e, page: 0 }));
  };

  useEffect(() => {
    if (exported) {
      const url = window.URL.createObjectURL(
        new Blob([exported], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = `Monthly-Revenue-Analysis-${new Date().getTime()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      actions.clearExported();
    }
  }, [exported, actions]);

  const handleExportClick = async (filters) => {
    const name = `Monthly Revenue Analysis from ${formatDate(
      filters.arrival_date,
      "MM/dd/yyyy"
    )} to ${formatDate(filters.completed_date, "MM/dd/yyyy")}`;

    const data = report.data.map((el) => ({
      ...el,
      hours_balance: el.hours_balance
        ? `${Number.parseFloat(el.hours_balance)?.toFixed(2)}`
        : "0",
      percent_balance: el.percent_balance
        ? `${Number.parseFloat(el.percent_balance)?.toFixed(2)}%`
        : ""
    }));

    await downloadCSV(name, data, LEVEL_3_COLUMNS, name);
  };

  const handleExportPDF = (filters) => {
    const payload = {
      data: filters,
      type: "MONTHLY_REVENUE_ANALYSIS",
      format: "pdf"
    };
    actions.performExport(payload);
  };

  return (
    <React.Fragment>
      <Filters
        loading={loading}
        onCSVExport={handleExportClick}
        onPDFExport={handleExportPDF}
        exportDisabled={loading || exporting || !report?.data?.length}
      />
      {loading ? (
        <div className="cps-loading">
          <Loading />
        </div>
      ) : null}
      {!loading ? (
        <div className="content-wrapper">
          <ReactTable
            sortable={false}
            className="-highlight"
            data={report?.data}
            columns={LEVEL_3_COLUMNS}
            pages={Math.ceil(report?.data?.length / state.pageSize)}
            pageSize={state.pageSize}
            page={state.page}
            showPagination
            showPageSizeOptions={!isMobile}
            noDataText="No data to show"
            onPageSizeChange={onPageSizeChange}
            onPageChange={onPageChange}
          />{" "}
        </div>
      ) : null}
    </React.Fragment>
  );
};

MonthlyRevenueAnalysis.propTypes = {
  report: PropTypes.object,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  exported: PropTypes.bool,
  exporting: PropTypes.bool,
  actions: PropTypes.object
};

MonthlyRevenueAnalysis.defaultProps = {
  report: {},
  isMobile: false,
  loading: false
};

function mapStatesToProps(state) {
  return {
    report: state.reducers.report,
    loading: state.reducers.loading,
    exported: state.reducers.exported,
    exporting: state.reducers.exporting
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...reportActions,
        ...userActions,
        ...exportActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(MonthlyRevenueAnalysis);
